import logo from "../../assets/imgs/logo.svg";
const Logo = () => {
  return <img src={logo} alt="The Accounter" />;
};

export default Logo;
